export type EntityIdType = 'appliance' | 'controller' | 'actuator' | 'detector';

const ENTITY_ID_PREFIX: Record<EntityIdType, string> = {
    appliance: 'D',
    controller: 'C',
    actuator: 'A',
    detector: 'M'
};

export const formatEntityId = (type: EntityIdType, id: number | string): string => {
    return `${ENTITY_ID_PREFIX[type]}${id}`;
};

export const formatOptionalEntityId = (
    type: EntityIdType,
    id: number | string | null | undefined,
    fallback = 'Unknown'
): string => {
    if (id === null || id === undefined) {
        return fallback;
    }

    return formatEntityId(type, id);
};
